<template>
  <div class="animated fadeIn">
    <component :entity="entity" :http="http" :is="entity.indexComponent" :card="true">
      <div slot="header"  class="row">
        <div class="col">
          <h1 v-if="entity.name" slot="header">
            {{ entity.name }}
          </h1>
        </div>
        <div class="col">
          <router-link :to="createRoute" v-if="entity.create !== false">
            <label class="btn btn-primary float-right" style="margin: 4px 0px 0px;">
              <i class="fa fa-plus mr-1"></i> Incluir
            </label>
          </router-link>

          <a :href="entity.order" v-if="entity.order">
            <label class="btn btn-secondary float-right" style="margin: 4px;">
              <i class="fa fa-sort mr-1"></i> Ordernar
            </label>
          </a>

          <a :href="entity.report_link" v-if="entity.report === true">
            <label class="btn btn-success float-right" style="margin: 4px 0px 0px;">
              <i class="fa fa-download mr-1"></i> Exportar
            </label>
          </a>

          <span v-if="entity.export === true">
            <label class="btn btn-secondary float-right export-all"
              style="margin: 4px 4px;"
              @click.stop.prevent="exportDataAll">
              <i class="fa fa-download mr-1"></i> Exportar Tudo
            </label>
          </span>

          <span v-if="entity.exportpromocode === true">
            <label class="btn btn-secondary float-right export-all"
              style="margin: 4px 4px;"
              @click.stop.prevent="exportPromocodes">
              <i class="fa fa-download mr-1"></i> Exportar Tudo
            </label>
          </span>

        </div>
      </div>
    </component>
  </div>
</template>

<script>
  import exportFromJSON from 'export-from-json'
  import { resolveHTTP } from '@/services/api'
  import { compact, without, forEach } from 'lodash'

  export default {
    props: {
      http: {
        type: null,
        required: true
      },

      entity: {
        type: Object,
        required: true
      }
    },

    computed: {
      createRoute () {
        return {
          name: 'manageables.create',
          params: {
            entity: this.entity.key
          }
        }
      }
    },

    methods: {
      exportDataSubs: function () {
        const self = this
        self.processing = true
        self.$Progress.start()
        self.showConfirmModal = false
        resolveHTTP(self.entity.url).index(self.entity.exportOptions.search)
          .then((res) => {
            self.$Progress.finish()
            self.processing = false
            self.$toasted.success('Aguarde seu download iniciará em alguns instantes.')
            self.$emit('refresh')
            let data = without(compact(res.data.collection), null)
            forEach(data, (value, key) => {
              forEach(self.entity.exportOptions.omit, (omit) => {
                delete data[key][omit]
              })
            })
            const fileName = self.entity.exportOptions.name
            const exportType = self.entity.exportOptions.type
            exportFromJSON({ data, fileName, exportType })
          })
          .catch(() => {
            self.$Progress.fail()
            self.processing = false
            self.$toasted.info('Houve um erro ao tentar exportar os dados, por favor tente novamente mais tarde.')
          })
      },
      exportDataAll: function () {
        const self = this
        self.processing = true
        self.$Progress.start()
        self.showConfirmModal = false
        resolveHTTP(self.entity.url).index(self.entity.exportOptions.searchAll)
          .then((res) => {
            self.$Progress.finish()
            self.processing = false
            self.$toasted.success('Aguarde seu download iniciará em alguns instantes.')
            self.$emit('refresh')
            let data = without(compact(res.data.collection), null)
            forEach(data, (value, key) => {
              forEach(self.entity.exportOptions.omit, (omit) => {
                delete data[key][omit]
              })
            })
            const fileName = self.entity.exportOptions.nameAll
            const exportType = self.entity.exportOptions.type
            exportFromJSON({ data, fileName, exportType })
          })
          .catch(() => {
            self.$Progress.fail()
            self.processing = false
            self.$toasted.info('Houve um erro ao tentar exportar os dados, por favor tente novamente mais tarde.')
          })
      },
      exportPromocodes: function () {
        const self = this
        self.processing = true
        self.$Progress.start()
        self.showConfirmModal = false
        resolveHTTP(self.entity.exportOptions.url).index(self.entity.exportOptions.searchAll)
          .then((res) => {
            self.$Progress.finish()
            self.processing = false
            self.$toasted.success('Aguarde seu download iniciará em alguns instantes.')
            self.$emit('refresh')
            let data = without(compact(res.data.collection), null)
            console.dir(data)
            const fileName = self.entity.exportOptions.nameAll
            const exportType = self.entity.exportOptions.type
            exportFromJSON({ data, fileName, exportType })
          })
          .catch((res) => {
            console.dir(res)
            self.$Progress.fail()
            self.processing = false
            self.$toasted.info('Houve um erro ao tentar exportar os dados, por favor tente novamente mais tarde.')
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/manageables/Index.vue